<template>
  <transition name="fade">
    <div
      v-if="isSwitchingOrganizations"
      class="org-switch-loading-screen"
      data-testid="orgSwitchLoading-screen"
    >
      <LayoutLogin data-testid="orgSwitchLoading-layout-login">
        <template v-slot:content>
          <div
            class="org-switch-loading-screen__progress"
            data-testid="orgSwitchLoading-div-progress"
          >
            <v-progress-linear
              data-testid="orgSwitchLoading-progress"
              color="light-blue"
              :active="true"
              :height="8"
              :indeterminate="true"
              :rounded="true"
            />
            <p
              class="h6 text-center white--text mt-4"
              data-testid="orgSwitchLoading-message"
            >
              {{ message }}
            </p>
          </div>
        </template>
      </LayoutLogin>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

import LayoutLogin from '@/components/Core/Layout/LayoutLogin'

export default {
  name: 'OrgSwitchLoadingScreen',

  components: {
    LayoutLogin,
  },

  computed: {
    ...mapGetters(['isSwitchingOrganizations', 'switchingToOrganizationName']),

    message() {
      if (!this.switchingToOrganizationName) {
        return this.$t('organization_settings.switch_organization.switching')
      }

      return this.$t('organization_settings.switch_organization.switching_to', {
        organizationName: this.switchingToOrganizationName,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.org-switch-loading-screen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 300;
  background: #0c243f;

  &__progress {
    width: 320px;
  }
}
</style>
